import { Map } from 'immutable';
import { locationsActions } from './actions';
import { createLocation  } from './location';

export const initialState = new Map({
  currentLocationId: null
});

export function locationsReducer(state = initialState, {payload, type}) {
  switch (type) {
    case locationsActions.FETCH_LOCATION_SUCCESS:
      return state.withMutations(locations => {
          const locationId = Number(payload.id);
          if (locationId )
            locations.set(locationId, createLocation(payload));
      });
      case locationsActions.LOAD_LOCATION:
        return state.set('currentLocationId', payload.id);
    default:
      return state;
  }
}
